import { create } from 'zustand'

interface UIState {
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
  selectedRunId: string | null
  setSelectedRunId: (id: string | null) => void
  expandedRunIds: Set<string>
  toggleRunExpanded: (id: string) => void
  analysisChatOpen: boolean
  toggleAnalysisChat: () => void
  modals: {
    preview: boolean
    rerun: boolean
    newProject: boolean
    editProject: boolean
    assignProject: boolean
    userPrediction: boolean
    apiKey: boolean
    adminLogin: boolean
    scheduleReruns: boolean
  }
  openModal: (modal: keyof UIState['modals']) => void
  closeModal: (modal: keyof UIState['modals']) => void
}

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: true,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed: boolean) => set({ sidebarCollapsed: collapsed }),
  selectedRunId: null,
  setSelectedRunId: (id) => set({ selectedRunId: id }),
  expandedRunIds: new Set(),
  toggleRunExpanded: (id) =>
    set((state) => {
      const newSet = new Set(state.expandedRunIds)
      if (newSet.has(id)) {
        newSet.delete(id)
      } else {
        // Max 2 expanded at once
        if (newSet.size >= 2) {
          const first = Array.from(newSet)[0]
          newSet.delete(first)
        }
        newSet.add(id)
      }
      return { expandedRunIds: newSet }
    }),
  analysisChatOpen: false,
  toggleAnalysisChat: () => set((s) => ({ analysisChatOpen: !s.analysisChatOpen })),
  modals: {
    preview: false,
    rerun: false,
    newProject: false,
    editProject: false,
    assignProject: false,
    userPrediction: false,
    apiKey: false,
    adminLogin: false,
    scheduleReruns: false,
  },
  openModal: (modal) =>
    set((state) => ({
      modals: { ...state.modals, [modal]: true },
    })),
  closeModal: (modal) =>
    set((state) => ({
      modals: { ...state.modals, [modal]: false },
    })),
}))

